export const createBankAccountItems = (messages = []) => {
  return messages.map(({ id, name, description, bankAccountNumber }) => {
    return {
      id,
      title: name,
      text: `${description || ''} #${bankAccountNumber?.replace(/\D/g, '')}`,
    };
  });
};
